import { GitHub, Instagram, Linkedin, Mail } from "react-feather";

const socials = [
	{
		link: "https://www.instagram.com/sdcmvjce?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==",
		icon: <Instagram />,
		text: "Instagram",
		username: "SoftwareDevelopmentClub/Instagram",
		linkText: "instagram.com/SoftwareDevelopmentClub",
	},
	{
		link: "https://www.linkedin.com/company/software-development-club-mvjce/",
		icon: <Linkedin />,
		text: "LinkedIn",
		username: "SoftwareDevelopmentClub/Linkedin",
		linkText: "linkedin.com/SoftwareDevelopmentClub",
	},
	{
		link: "https://github.com/sdc247",
		icon: <GitHub />,
		text: "GitHub",
		username: "SoftwareDevelopmentClub/Github",
		linkText: "github.com/SoftwareDevelopmentClub",
	},
	{
		link: "mailto: sdcmvjce@gmail.com",
		icon: <Mail />,
		text: "Email",
		username: "SoftwareDevelopmentClub/Email",
		linkText: "sdcmvjce@gmail.com",
	},
];

export default socials;
